import React from 'react';
import styled from 'styled-components';
import { CampaignStatsSummary } from '../../model/CampaignStatsResult';

interface IProps{
    summary:CampaignStatsSummary
}

const Wrapper = styled.div`
.container {
    display:flex;
    gap: 2rem;
}

.summary-item{
   width:200px;
   flex: 0 0 auto;
    padding:2rem 1rem;
    color:#fff;
    border-radius: 5px;
}
.summary-item__count{
    font-size: 2.5rem;
}
.summary-item__text{
    
}
.delivered-summary {
    background-color: #25AFF4;
}
.opens {
    background-color: #22C33C;
}
.clicks {
    background-color: #F49D25;
}
.unsubscribes {
    background-color: #F42525;
}
`;

const SummaryItem = (className:String, text:String, count:number)=>{
    return <div className={`${'summary-item'} ${className}`}>

    <div className='summary-item__count'>{count}</div>
    <div>{text} </div>

    </div>
    
}

const CampaignStatsSummaryComponent: React.FC<IProps>= (props:IProps) => {
    const { summary } = props;
    return <Wrapper>
   <div className='container'>
    { SummaryItem('delivered-summary', 'Delivered', summary.delivered)}
    { SummaryItem('opens', 'Opens', summary.opens)}
    { SummaryItem('clicks', 'Clicks', summary.clicks)}
    { SummaryItem('unsubscribes', 'Unsubscribes', summary.unsubscribes)}

   </div>
   
</Wrapper>
}

export default CampaignStatsSummaryComponent